.container {
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: auto;
}

.slideContainer {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /*overflow: hidden;*/
  /*max-width: 600px; !* up to 600px wide *!*/
  aspect-ratio: 1 / 1; /* always a perfect square */
  overflow: hidden;
}

.image {
  width: 100%;
  height: 100%;
  /*object-fit: contain;*/
  border-radius: 5px;
  corner-shape: superellipse(1.18);
  object-fit: cover; /* fills & crops to cover the box */
  object-position: 50% 35%;
}

.thumbnails {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
}

.thumbnail {
  width: calc((100% - 10px) / 3);
  height: calc((100% - 10px) / 3);
  object-fit: cover;
  cursor: pointer;
  opacity: 0.7;
  border-radius: 5px;
  transition: opacity 0.2s ease;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  object-position: 50% 35%;
}

.thumbnail:hover,
.active {
  opacity: 1;
}

@media (max-width: 480px) {
  .container {
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 100%;
    position: relative;
  }
  .slideContainer {
    width: 66.66%;
    height: auto;
  }
  .image {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 3px;
  }
  .thumbnails {
    width: 33.33%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    margin-top: 0;
  }
  .thumbnail {
    width: calc(100% - 3.33px);
    height: calc((100% - 3.33px) / 3);
    object-fit: cover;
    border-radius: 3px;
  }
}
